import { render, staticRenderFns } from "./Publicacoes.vue?vue&type=template&id=7aac1036&scoped=true"
import script from "./Publicacoes.vue?vue&type=script&lang=js"
export * from "./Publicacoes.vue?vue&type=script&lang=js"
import style0 from "./Publicacoes.vue?vue&type=style&index=0&id=7aac1036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aac1036",
  null
  
)

export default component.exports